import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {ReactiveFormsModule} from "@angular/forms";
import {HttpHelpersModule} from "../http/http-helpers.module";
import {HttpClientModule} from "@angular/common/http";
import {AppSettingsModule} from "../app-settings/app-settings.module";
import {BootstrapModalModule} from "../bootstrap-modal/bootstrap-modal.module";
import {ErrorModule} from "../errors/error.module";
import {SoftwareSolutionsService} from "./software-solutions.service";
import {DeviceService} from "../device/device.service";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";

@NgModule({
  providers: [
    SoftwareSolutionsService,
    DeviceService,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    HttpHelpersModule,
    HttpClientModule,
    AppSettingsModule,
    BootstrapModalModule,
    ErrorModule,
    NgbModule,
  ],
  declarations: [],
  exports: [
    NgbModule,
  ],
  entryComponents: [],
})

export class SoftwareSolutionsModule {}
